import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-244cb6c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "box",
  id: "box"
}
const _hoisted_3 = {
  class: "box",
  id: "box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComp = _resolveComponent("TableComp")!
  const _component_GraphComp = _resolveComponent("GraphComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TableComp, {
        dataset: _ctx.dataset,
        getdata: _ctx.getdata
      }, null, 8, ["dataset", "getdata"])
    ]),
    _createElementVNode("div", {
      onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.res && _ctx.res(...args))),
      class: "handler"
    }, null, 32),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_GraphComp, {
        prac: _ctx.data,
        target: _ctx.target,
        source: _ctx.source
      }, null, 8, ["prac", "target", "source"])
    ])
  ]))
}